<template>
    <div class="control-panel-content container-fluid">
        <h3>Er zijn {{ unreadCount }} nieuwe bericht(en).</h3>
        <table class="table voicemails-list">
            <thead>
                <tr>
                    <th>Afzender</th>
                    <th>Beluisteren</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="voicemail in voicemails" :key="voicemail.id"
                    class="voicemail"
                    :class="[voicemail.isRead == 1 ? 'voicemail-read' : 'voicemail-unread']">
                    <td class="voicemail-name">{{ voicemail.from }}</td>
                    <td class="voicemail-audio">
                        <audio controls :src="voicemail.audioFile" @play="markAsRead(voicemail)"></audio>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import api from '@/repository/api.js'
import { mapState } from 'vuex';

export default {
    data() {
        return {
            voicemails: [],
            messages: [],
        }
    },
    computed: {
        ...mapState(['session']),
        unreadCount() {
            return this.voicemails.filter(msg => msg.isRead === false).length;
        }
    },
    async mounted() {
        await this.loadMessages();
        this.voicemails = this.filterVoicemails();
        console.log(this.voicemails);
    },
    watch: {
        session() {
            this.voicemails = this.filterVoicemails();
        },
    },
    methods: {
        async loadMessages() {
            try {
                const token = this.$store.state.sessionToken;
                const response = await api.getAllMessages(token);
                this.messages = response.data.data || [];
                console.log("Voicemail messages loaded:", this.messages);
            } catch (err) {
                console.error("Error loading voicemail messages:", err);
                this.messages = [];
            }
        },
        filterVoicemails() {
            let vms = [];
            const steps = this.$store.state.session.steps;
            const team = this.$store.state.team;
            const now = Date.now();
            if (steps) {
                // For each step in the session, check if there is a matching dynamic
                // message and if it has a matching startTime in the session, show it if so.
                steps.forEach(step => {
                    const message = this.messages.find(m => m.messageId == step.dilemmaId);
                    if (message
                        // Make sure it has a start time and that the start time is in the past
                        && step.startTime
                        && now > new Date(step.startTime).getTime()
                        // Only show voicemails
                        && step.isVoicemail
                        // Make sure it is meant for this team
                        && (typeof(step.teams) === "undefined" || (step.teams && step.teams.includes(team)))
                    ) {
                        vms.push({
                            id: step.dilemmaId,
                            dilemmaId: step.dilemmaId,
                            from: message.persona ? message.persona.displayName : '',
                            audioFile: message.attachments && message.attachments.length > 0 
                                ? '/attachments/' + message.attachments[0] 
                                : '',
                            isRead: step.isRead,
                        });
                    }
                });
            }
            return vms;
        },
        markAsRead(voicemail) {
            if (!voicemail.isRead) {
                const token = this.$store.state.sessionToken;
                api.emailOpened(token, voicemail.dilemmaId);
                this.$store.dispatch('markAsRead', voicemail.dilemmaId);
            }
        }
    }
};
</script>

<style scoped>
h3 {
    margin: 1rem;
}

table {
    border-collapse: unset;
    border-spacing: 3px;
}

.table th {
    border-top: 0;
    border-bottom: 0;
}

.control-panel-voicemail {
    padding: 20px;
}

.voicemails-list {
    list-style-type: none;
    padding: 0;
}

.voicemails-list li {
    margin-bottom: 20px;
}

tr.voicemail-read {
    border-radius: 1rem;
}

td a {
    color: black;
}

.voicemail-read td,
.voicemail-unread td {
    font-size: 1.6rem;
}

.voicemail {
    transition: background-color 0.2s;
}
.voicemail-read {
    background-color: transparent;
}

.voicemail-unread {
    font-weight: 700;
}

.voicemail-unread td {
    background-color: var(--color-primary-extra-light);
}

.voicemail-unread td:first-child {
    border-top-left-radius: 2rem;
    border-bottom-left-radius: 2rem;
}

td:first-child {
    padding-left: 1.5rem;
    padding-right: 0;
}

.voicemail-unread td:last-child {
    /* border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem; */
}

tr,
td {
    border: 0;
    border-top: 0;
    /* Resetting any previous borders */
}

.voicemail-name {
    width: 30%;
}

.voicemail-audio {
    width: 30%;
    line-height: 0;
}

audio {
    background: white;
    border: 2px solid var(--color-primary);
    /* border-radius: 27px; */
    width: 100%;
    /* transform: scale(1.25) translate(-7%, -8px); */
}
</style>

